import { render, staticRenderFns } from "./LandingpageSwitch.vue?vue&type=template&id=9305123c&scoped=true"
import script from "./LandingpageSwitch.vue?vue&type=script&lang=ts"
export * from "./LandingpageSwitch.vue?vue&type=script&lang=ts"
import style0 from "./LandingpageSwitch.vue?vue&type=style&index=0&id=9305123c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9305123c",
  null
  
)

export default component.exports